<div>
  <button style="float: right;" title="Salva" (click)="closeDialog()" mat-icon-button color="warn"
          aria-label="icon-button save">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div>
  <div style="width: 100%; text-align: center; margin-top: 2%">
    <h1>Posizione dispositivo:</h1>
    <div [innerHtml]="this.sanitizedIframeContent"></div>

  </div>
</div>
